import { render } from "./LeadNoAnswer.vue?vue&type=template&id=665764ff"
import script from "./LeadNoAnswer.vue?vue&type=script&lang=js"
export * from "./LeadNoAnswer.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/preflight.unbundledlegalhelp.dev.farm/releases/000000/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__